module.exports = __webpack_public_path__ + "img/top-home-service-bg.c25c4d4.jpg";